import { defineComponent as _defineComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'ManualButton',
  emits: ["click"],
  setup(__props, { expose: __expose }) {
  __expose();



const __returned__ = {  }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})

//@ sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxpYnMvZmVhdHVyZS9wcm9kdWN0LWNvbmZpZ3VyYXRvci9zcmMvbGliL3Z1ZS1hcHBzL29yZGVyLWZvcm0vbW9kdWxlcy9hZGRyZXNzLWF1dG8tY29tcGxldGUvY29tcG9uZW50cy9NYW51YWxCdXR0b24udnVlIl0sInNvdXJjZXNDb250ZW50IjpbIjxzY3JpcHQgbGFuZz1cInRzXCIgc2V0dXA+XG5kZWZpbmVFbWl0czx7IGNsaWNrOiBbXSB9PigpO1xuPC9zY3JpcHQ+XG5cbjx0ZW1wbGF0ZT5cbiAgPGJ1dHRvbiBjbGFzcz1cIm1hbnVhbC1idXR0b25fX2J1dHRvblwiIHR5cGU9XCJidXR0b25cIiBAY2xpY2sucHJldmVudD1cIiRlbWl0KCdjbGljaycpXCI+XG4gICAgPHNsb3QgLz5cbiAgPC9idXR0b24+XG48L3RlbXBsYXRlPlxuXG48c3R5bGU+XG4ubWFudWFsLWJ1dHRvbl9fYnV0dG9uIHtcbiAgYm9yZGVyOiBub25lO1xuICBiYWNrZ3JvdW5kOiBub25lO1xuICBmb250LXNpemU6IDgwJTtcbiAgdGV4dC1kZWNvcmF0aW9uOiB1bmRlcmxpbmU7XG4gIGN1cnNvcjogcG9pbnRlcjtcbn1cbjwvc3R5bGU+XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7OyJ9